import { APIDecoratorWithBaseURI } from '../../Service/api'

export interface useValidationProps {
  fetcher: (x: useAdavanceInvocePorps) => Promise<any>
}
type useAdavanceInvocePorps = {
  payload: TrackerData
}

export interface GoogleAdsPixelItem {
  value: string
  convertion_id: string
  label: string
}

export interface TrackerData {
  facebook: string | null
  google: string | null
  google_ads: GoogleAdsPixelItem[]
  tiktok: string | null
}

export type TrackerPayload = TrackerData & {
  event_id: number | string
}

export const useTrackerUpdate = (): useValidationProps => {
  const fetcher = async (payload: useAdavanceInvocePorps) => {
    const url: string = `/analytics/tracker/updateEventTrackerIds`

    return await APIDecoratorWithBaseURI().put(url, {
      ...payload,
    })
  }

  return {
    fetcher,
  }
}
